export const assistancesCmn = [
  { id: '1', value: '没有' },
  { id: '13', value: '没有，但我需要一些帮助（上门服务' },
  { id: '4', value: '轮椅（不能折叠' },
  { id: '15', value: '轮椅（可以折叠' },
  { id: '3', value: '助行架' },
  { id: '6', value: '我需要轮床 / 担架床' },
];
